<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Galería de medios</h3>
            </div>
        </div>
        <div v-show="imagenes.length > 0" class="row">
            <div class="col-xs-12">
                <h5>Imágenes</h5>
            </div>
            <div class="col-xs-12 col-md-4" v-for="imagen in imagenes" :key="imagen.id">
                <a :href="imagen.url_archivo" target="_blank"><img :src="imagen.url_archivo" width="100%" :alt="imagen.url_archivo" /></a>
            </div>
        </div>
        <div v-show="videos.length > 0" class="row">
            <div class="col-xs-12">
                <h5>Videos</h5>
            </div>
            <div class="col-xs-12 col-md-4" v-for="video in videos" :key="video.id">
                <video style="width: 100%;" :src="video.url_archivo" controls></video>
            </div>
        </div>
        <div v-show="audios.length > 0" class="row">
            <div class="col-xs-12">
                <h5>Audios</h5>
            </div>
            <div class="col-xs-12 col-md-4" v-for="audio in audios" :key="audio.id">
                <audio controls>
                    <source :src="audio.url_archivo" type="audio/mp4">
                </audio>
            </div>
        </div>
        <div class="modal-buttons"><button @click="$emit('cerrar')" class="btn-danger btn--text"><i class="fa fa-ban"></i><span>Cerrar</span></button></div>
    </div>
</template>

<script>
export default {
    computed: {
        imagenes: function () {
            let imagenes = [];
            for (let i = 0; i < this.medios.length; i++) {
                if (this.medios[i].tipo_mensaje === 'I') {
                    imagenes.push(this.medios[i]);
                }
            }
            return imagenes;
        },
        videos: function () {
            let videos = [];
            for (let i = 0; i < this.medios.length; i++) {
                if (this.medios[i].tipo_mensaje === 'V') {
                    videos.push(this.medios[i]);
                }
            }
            return videos;
        },
        audios: function () {
            let audios = [];
            for (let i = 0; i < this.medios.length; i++) {
                if (this.medios[i].tipo_mensaje === 'A') {
                    audios.push(this.medios[i]);
                }
            }
            return audios;
        }
    },
    props: {
        consultaId: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function () {
        return {
            medios: []
        };
    },
    methods: {
        consultarMedios: function () {
            axios.get(url + '/' + this.consultaId + '/medios').then(({data}) => {
                this.medios = data;
                if (this.medios.length === 0) {
                    swal('No se ha encontrado medios disponibles.', 'Aviso', 'warning');
                    this.$emit('cerrar');
                }
            });
        }   
    },
    mounted : function () {
        this.consultarMedios();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/consultas/GaleriaMedios.vue